<div class="modal-content">
  <h2 class="modal-header">¡Todo listo!</h2>
  <p class="modal-message">
    Ya formas parte . ¡Diviértete y disfruta de todo lo que tenemos para ti!
  </p>

  <div class="modal-buttons">
    <ion-button color="primary" (click)="closeModal()">Continuar</ion-button>
  </div>
</div>
